import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: 'child-cell',
    template: `<span *ngIf="this.params.isexpand">{{this.params.data.Comment.substring(0,22)}}
    <svg class="puls-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" (click)="ExpandHeight()">
  <g id="Group_46" data-name="Group 46" transform="translate(-1658.58 -173.58)">
    <circle id="Ellipse_16" data-name="Ellipse 16" cx="7.072" cy="7.072" r="7.072" transform="matrix(0.695, 0.719, -0.719, 0.695, 1668.755, 173.58)" fill="#acacac"/>
    <path id="delete_cross" d="M4.183.226,2.751,1.658,1.319.226A.773.773,0,0,0,.226,1.319L1.658,2.751.226,4.183A.773.773,0,0,0,1.319,5.276L2.751,3.844,4.183,5.276A.773.773,0,0,0,5.5,4.73a.765.765,0,0,0-.226-.546L3.844,2.751,5.275,1.319A.773.773,0,0,0,4.183.226Z" transform="matrix(0.695, 0.719, -0.719, 0.695, 1668.744, 179.692)" fill="#fff"/>
  </g>
</svg>

    </span>
    <span *ngIf="!this.params.isexpand">{{this.params.data.Comment}}
    </span>
   `,
    styles: []
})
export class ChildCommentRenderer implements ICellRendererAngularComp {
    public params: any;

    agInit(params: any): void {
        this.params = params;
        if(this.params.data.Comment)
        {
            this.params.isexpand=this.params.data.Comment.length > 22 ? true : false;
        }else
        {
            this.params.isexpand=false;
        }
        
    }

    
    refresh(): boolean {
        return false;
    }

    ExpandHeight(){
      this.params.context.componentParent.ExpandComment(this.params.data);
    }
}